<template>
  <div>
    <page-header title="风险中心" description="聚焦风险证据、重点评论和处理进展">
      <el-button v-if="run" :loading="exporting" @click="download">{{exporting?'导出中':'导出 XLSX'}}</el-button>
    </page-header>
    <el-card v-loading="loading">
      <el-form inline @submit.native.prevent="query">
        <el-select v-model="level" clearable placeholder="风险等级">
          <el-option v-for="value in ['高', '中', '低']" :key="value" :value="value" />
        </el-select>
        <el-select v-model="status" clearable placeholder="处理状态">
          <el-option v-for="value in statuses" :key="value" :value="value" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" :disabled="loading" native-type="submit">查询</el-button>
      </el-form>
      <risk-table :items="filtered" @open="open" />
    </el-card>
    <risk-process-drawer :visible.sync="drawer" :risk="selected" @saved="load" />
  </div>
</template>

<script>
import { yuqingApi } from '@/api/yuqing'
import PageHeader from '../components/PageHeader.vue'
import RiskTable from '../components/RiskTable.vue'
import RiskProcessDrawer from './RiskProcessDrawer.vue'

export default {
  components: { PageHeader, RiskTable, RiskProcessDrawer },
  data () {
    return {
      items: [],
      run: null,
      loading: false,
      level: '',
      status: '',
      appliedLevel: '',
      appliedStatus: '',
      statuses: ['待确认', '处理中', '已关闭', '误报'],
      drawer: false,
      selected: null,
      exporting: false
    }
  },
  computed: {
    filtered () {
      return this.items.filter(item =>
        (!this.appliedLevel || item.risk_level === this.appliedLevel) &&
        (!this.appliedStatus || item.process_status === this.appliedStatus)
      )
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        const [risks, latest] = await Promise.all([
          yuqingApi.get('risk-records'),
          yuqingApi.get('runs/latest')
        ])
        this.items = risks.risks || []
        this.run = latest.run
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.loading = false
      }
    },
    query () {
      this.appliedLevel = this.level
      this.appliedStatus = this.status
    },
    open (risk) {
      this.selected = risk
      this.drawer = true
    },
    download () {
      if (this.exporting || !this.run) return
      this.exporting = true
      yuqingApi.download(`jobs/${this.run.id}/risks.xlsx`)
      this.$message.success('风险数据文件已开始下载')
      window.setTimeout(() => { this.exporting = false }, 800)
    }
  }
}
</script>
